import { Accordion, Stack, Text, Title } from '@mantine/core';
import { useStrings } from '@/i18n/useLang';

/** Long-form explanatory content for SEO and AdSense. Mirrors the static copy in
 *  index.html (which crawlers read before JS runs — see plan FINDING-3). */
export function SeoContent() {
  const t = useStrings();

  return (
    <Stack gap="xl" mt="xl">
      <section>
        <Title order={2} mb="xs">
          {t.seo.aboutTitle}
        </Title>
        <Text c="dimmed">{t.seo.aboutBody}</Text>
      </section>

      <section>
        <Title order={2} mb="xs">
          {t.seo.pwTitle}
        </Title>
        <Text c="dimmed">{t.seo.pwBody}</Text>
      </section>

      <section>
        <Title order={2} mb="sm">
          {t.seo.faqTitle}
        </Title>
        <Accordion variant="separated">
          {t.seo.faq.map((item) => (
            <Accordion.Item key={item.q} value={item.q}>
              <Accordion.Control>{item.q}</Accordion.Control>
              <Accordion.Panel>{item.a}</Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      </section>
    </Stack>
  );
}
